import { PropTypes } from "@l2r-front/l2r-proptypes"
import { Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./RoadAssesmentList.styled"

export const RoadAssesmentList = (props) => {
    const {
        children,
        disabled,
        listKey,
        title,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Container disabled={disabled} id={listKey} isMobile={isMobile}>
            {title && <Styled.Title id={`${listKey}-title`}>
                <Typography variant="H2">{title}</Typography>
            </Styled.Title>}
            <Styled.ListWrapper>
                <Styled.List>
                    {children}
                </Styled.List>
            </Styled.ListWrapper>
        </Styled.Container>
    )
}

RoadAssesmentList.defaultProps = {
    disabled: false,
}

RoadAssesmentList.propTypes = {
    disabled: PropTypes.bool,
    listKey: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
}